// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__wKwqv","legacyBtn":"MutateMid_legacyBtn__16urc"};